/* eslint-disable arrow-body-style */

import moment from 'moment';
import { EventTypes } from 'redux-segment';

import { GET_CATEGORIES_FAILURE, GET_CATEGORIES_REQUEST, GET_CATEGORIES_SUCCESS } from 'actions/shared.types';
import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';
import asArray from 'utils/arrays/asArray.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';

import { buildServiceTaxSettingsPayload, cloneServiceForEdit, matchRoleExecutionsForUpdate, normalizePrice, resolveTaxSettingsForSave } from 'onboarding/services/utils';

export const ADD_CATEGORY_REQUEST = 'ADD_CATEGORY_REQUEST';
export const ADD_CATEGORY_SUCCESS = 'ADD_CATEGORY_SUCCESS';
export const ADD_CATEGORY_FAILURE = 'ADD_CATEGORY_FAILURE';
export const EDIT_CATEGORY_REQUEST = 'EDIT_CATEGORY_REQUEST';
export const EDIT_CATEGORY_SUCCESS = 'EDIT_CATEGORY_SUCCESS';
export const EDIT_CATEGORY_FAILURE = 'EDIT_CATEGORY_FAILURE';
export const DELETE_CATEGORY_REQUEST = 'DELETE_CATEGORY_REQUEST';
export const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS';
export const DELETE_CATEGORY_FAILURE = 'DELETE_CATEGORY_FAILURE';
export const GET_SERVICES_REQUEST = 'GET_SERVICES_REQUEST';
export const GET_SERVICES_SUCCESS = 'GET_SERVICES_SUCCESS';
export const GET_SERVICES_FAILURE = 'GET_SERVICES_FAILURE';
export const ADD_SERVICE_REQUEST = 'ADD_SERVICE_REQUEST';
export const ADD_SERVICE_SUCCESS = 'ADD_SERVICE_SUCCESS';
export const ADD_SERVICE_FAILURE = 'ADD_SERVICE_FAILURE';
export const GET_SERVICE_REQUEST = 'GET_SERVICE_REQUEST';
export const GET_SERVICE_SUCCESS = 'GET_SERVICE_SUCCESS';
export const GET_SERVICE_FAILURE = 'GET_SERVICE_FAILURE';
export const EDIT_SERVICE_REQUEST = 'EDIT_SERVICE_REQUEST';
export const EDIT_SERVICE_SUCCESS = 'EDIT_SERVICE_SUCCESS';
export const EDIT_SERVICE_FAILURE = 'EDIT_SERVICE_FAILURE';
export const POST_SERVICE_TAXES_AND_FEES_REQUEST = 'POST_SERVICE_TAXES_AND_FEES_REQUEST';
export const POST_SERVICE_TAXES_AND_FEES_SUCCESS = 'POST_SERVICE_TAXES_AND_FEES_SUCCESS';
export const POST_SERVICE_TAXES_AND_FEES_FAILURE = 'POST_SERVICE_TAXES_AND_FEES_FAILURE';
export const GET_SERVICE_TAXES_AND_FEES_REQUEST = 'GET_SERVICE_TAXES_AND_FEES_REQUEST';
export const GET_SERVICE_TAXES_AND_FEES_SUCCESS = 'GET_SERVICE_TAXES_AND_FEES_SUCCESS';
export const GET_SERVICE_TAXES_AND_FEES_FAILURE = 'GET_SERVICE_TAXES_AND_FEES_FAILURE';
export const DELETE_SERVICE_REQUEST = 'DELETE_SERVICE_REQUEST';
export const DELETE_SERVICE_SUCCESS = 'DELETE_SERVICE_SUCCESS';
export const DELETE_SERVICE_FAILURE = 'DELETE_SERVICE_FAILURE';
export const POST_SERVICE_FOR_ROLE_REQUEST = 'POST_SERVICE_FOR_ROLE_REQUEST';
export const POST_SERVICE_FOR_ROLE_SUCCESS = 'POST_SERVICE_FOR_ROLE_SUCCESS';
export const POST_SERVICE_FOR_ROLE_FAILURE = 'POST_SERVICE_FOR_ROLE_FAILURE';
export const EDIT_SERVICE_FOR_ROLE_REQUEST = 'EDIT_SERVICE_FOR_ROLE_REQUEST';
export const EDIT_SERVICE_FOR_ROLE_SUCCESS = 'EDIT_SERVICE_FOR_ROLE_SUCCESS';
export const EDIT_SERVICE_FOR_ROLE_FAILURE = 'EDIT_SERVICE_FOR_ROLE_FAILURE';
export const DELETE_SERVICE_FOR_ROLE_REQUEST = 'DELETE_SERVICE_FOR_ROLE_REQUEST';
export const DELETE_SERVICE_FOR_ROLE_SUCCESS = 'DELETE_SERVICE_FOR_ROLE_SUCCESS';
export const DELETE_SERVICE_FOR_ROLE_FAILURE = 'DELETE_SERVICE_FOR_ROLE_FAILURE';
export const GET_SERVICE_TEMPLATES_REQUEST = 'GET_SERVICE_TEMPLATES_REQUEST';
export const GET_SERVICE_TEMPLATES_SUCCESS = 'GET_SERVICE_TEMPLATES_SUCCESS';
export const GET_SERVICE_TEMPLATES_FAILURE = 'GET_SERVICE_TEMPLATES_FAILURE';
export const CLEAR_SERVICES_STATE = 'CLEAR_SERVICES_STATE';
export const SET_SERVICE_SAVED = 'TOGGLE_SERVICE_SAVED';
export const REMOVE_SAVED_CATEGORIES_IDS = 'REMOVE_SAVED_CATEGORIES_IDS';
export const REMOVE_SAVED_SERVICES_IDS = 'REMOVE_SAVED_SERVICES_IDS';
export const CLEAR_REQUEST_ERROR = 'CLEAR_REQUEST_ERROR';
export const MARK_CATEGORIES_AS_FETCHED = 'MARK_CATEGORIES_AS_FETCHED';
export const CHANGE_SERVICE_POSITION = 'CHANGE_SERVICE_POSITION';
export const SAVE_SERVICE_POSITIONS_REQUEST = 'SAVE_SERVICE_POSITIONS_REQUEST';
export const SAVE_SERVICE_POSITIONS_SUCCESS = 'SAVE_SERVICE_POSITIONS_SUCCESS';
export const SAVE_SERVICE_POSITIONS_FAILURE = 'SAVE_SERVICE_POSITIONS_FAILURE';
export const CHANGE_CATEGORY_POSITION = 'CHANGE_CATEGORY_POSITION';
export const SAVE_CATEGORY_POSITIONS_REQUEST = 'SAVE_CATEGORY_POSITIONS_REQUEST';
export const SAVE_CATEGORY_POSITIONS_SUCCESS = 'SAVE_CATEGORY_POSITIONS_SUCCESS';
export const SAVE_CATEGORY_POSITIONS_FAILURE = 'SAVE_CATEGORY_POSITIONS_FAILURE';
export const GET_FUTURE_APPOINTMENTS_WITH_SERVICE_REQUEST = 'GET_FUTURE_APPOINTMENTS_WITH_SERVICE_REQUEST';
export const GET_FUTURE_APPOINTMENTS_WITH_SERVICE_SUCCESS = 'GET_FUTURE_APPOINTMENTS_WITH_SERVICE_SUCCESS';
export const GET_FUTURE_APPOINTMENTS_WITH_SERVICE_FAILURE = 'GET_FUTURE_APPOINTMENTS_WITH_SERVICE_FAILURE';
export const CLEAR_FUTURE_APPOINTMENTS_DATA = 'CLEAR_FUTURE_APPOINTMENTS_DATA';

// TODO: replace all 3 versions of this action with one new beGetServices
export function getCategories(salonId) {
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `salon/v2/${salonId}/category/services/`,
      authenticated: true,
      types: [GET_CATEGORIES_REQUEST, GET_CATEGORIES_SUCCESS, GET_CATEGORIES_FAILURE],
    },
  };
}

export const addCategory = (name, color, salonId) => {
  const category = {
    name,
    color,
  };
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(category),
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/category/salon/${salonId}/`,
      authenticated: true,
      types: [ADD_CATEGORY_REQUEST, ADD_CATEGORY_SUCCESS, ADD_CATEGORY_FAILURE],
      config,
    },
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'addCategory',
          properties: {
            name,
          },
        },
      },
    },
  };
};
export const editCategory = (category, salonId) => {
  const config = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(category),
  };
  if (!category.id) {
    return EDIT_CATEGORY_FAILURE;
  }
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/category/${category.id}/`,
      authenticated: true,
      types: [EDIT_CATEGORY_REQUEST, EDIT_CATEGORY_SUCCESS, EDIT_CATEGORY_FAILURE],
      config,
      params: { categoryId: category.id },
    },
  };
};
export const deleteCategory = (categoryId, salonId) => {
  const config = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/category/${categoryId}/`,
      authenticated: true,
      types: [DELETE_CATEGORY_REQUEST, DELETE_CATEGORY_SUCCESS, DELETE_CATEGORY_FAILURE],
      config,
      params: {
        categoryId,
      },
    },
  };
};
export const addInitialCategories = (salonId) => {
  return (dispatch) =>
    dispatch(addCategory('Colour', '#c93b7e', salonId)).then(
      () =>
        // eslint-disable-next-line promise/no-nesting
        void dispatch(addCategory('Cutting', '#3da49d', salonId)).then(
          () =>
            // eslint-disable-next-line promise/no-nesting
            void dispatch(addCategory('Styling', '#7300af', salonId)).then(
              // eslint-disable-next-line promise/no-nesting
              () => void dispatch(addCategory('Treatments', '#5e72d1', salonId)).then(alwaysNoop),
            ),
        ),
    );
};

export function getServices(salonId, categoryId) {
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/service/category/${categoryId}/`,
      authenticated: true,
      types: [GET_SERVICES_REQUEST, GET_SERVICES_SUCCESS, GET_SERVICES_FAILURE],
      params: {
        categoryId,
      },
    },
  };
}

export const postService = (service, salonId, categoryId) => {
  const serviceToAdd = {
    name: service.name,
    duration: moment(service.duration, 'HH:mm').format('HH:mm:ss'),
    processing: moment(service.processing, 'HH:mm').format('HH:mm:ss'),
    variable_pricing: service.variable_pricing,
    price: parseFloat(service.price),
  };
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(serviceToAdd),
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/service/category/${categoryId}/`,
      authenticated: true,
      types: [ADD_SERVICE_REQUEST, ADD_SERVICE_SUCCESS, ADD_SERVICE_FAILURE],
      config,
      params: {
        categoryId,
      },
    },
    meta: {
      analytics: {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'postService',
          properties: {
            name: service.name,
          },
        },
      },
    },
  };
};

export function getService(serviceId, salonId) {
  const config = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/service/${serviceId}/`,
      authenticated: true,
      types: [GET_SERVICE_REQUEST, GET_SERVICE_SUCCESS, GET_SERVICE_FAILURE],
      config,
    },
  };
}

const formatServiceTime = (value) => {
  if (!value) {
    return value;
  }

  const parsed = moment(value, ['HH:mm:ss', 'HH:mm'], true);
  return parsed.isValid() ? parsed.format('HH:mm:ss') : value;
};

export function putService(service, salonId) {
  const serviceToEdit = Object.assign({}, service);
  serviceToEdit.duration = formatServiceTime(service.duration);
  serviceToEdit.processing = formatServiceTime(service.processing);
  delete serviceToEdit.role_executions;
  const config = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(serviceToEdit),
  };
  if (!service.id) {
    return { type: EDIT_SERVICE_FAILURE };
  }
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/service/${service.id}/`,
      authenticated: true,
      types: [EDIT_SERVICE_REQUEST, EDIT_SERVICE_SUCCESS, EDIT_SERVICE_FAILURE],
      config,
      params: { serviceId: service.id },
    },
  };
}

export function deleteService(salonId, serviceId) {
  const config = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/service/${serviceId}/`,
      authenticated: true,
      types: [DELETE_SERVICE_REQUEST, DELETE_SERVICE_SUCCESS, DELETE_SERVICE_FAILURE],
      config,
      params: {
        serviceId,
      },
    },
  };
}

export function setServiceSaved(value) {
  return {
    type: SET_SERVICE_SAVED,
    value,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function postServiceTaxesAndFees({ taxes, fees, isTaxExempt, taxExemptReason, serviceId, salonId }) {
  const data = buildServiceTaxSettingsPayload({ taxes, fees, isTaxExempt, taxExemptReason });
  const config = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/service/${serviceId}/tax-settings/`,
      authenticated: true,
      types: [POST_SERVICE_TAXES_AND_FEES_REQUEST, POST_SERVICE_TAXES_AND_FEES_SUCCESS, POST_SERVICE_TAXES_AND_FEES_FAILURE],
      config,
    },
  };
}

export function getServiceTaxesAndFees({ serviceId, salonId }) {
  const config = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/service/${serviceId}/tax-settings/`,
      authenticated: true,
      params: {
        serviceId,
      },
      types: [GET_SERVICE_TAXES_AND_FEES_REQUEST, GET_SERVICE_TAXES_AND_FEES_SUCCESS, GET_SERVICE_TAXES_AND_FEES_FAILURE],
      config,
    },
  };
}

export function postServiceDetailsForRole(serviceDetails, serviceId, salonId) {
  const data = {
    service: serviceId,
    price: normalizePrice(serviceDetails.price) || 0,
    duration: formatServiceTime(serviceDetails.duration),
    processing: formatServiceTime(serviceDetails.processing),
  };
  const config = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/role/services/${serviceDetails.role_id}/`,
      authenticated: true,
      types: [POST_SERVICE_FOR_ROLE_REQUEST, POST_SERVICE_FOR_ROLE_SUCCESS, POST_SERVICE_FOR_ROLE_FAILURE],
      config,
    },
  };
}

export function putServiceDetailsForRole(serviceDetails, serviceId, salonId, updateFlags) {
  const data = {
    ...updateFlags,
    service: serviceId,
    price: normalizePrice(serviceDetails.price),
    duration: formatServiceTime(serviceDetails.duration),
    processing: formatServiceTime(serviceDetails.processing),
  };
  const config = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/role/services/${serviceDetails.role_id}/`,
      authenticated: true,
      types: [EDIT_SERVICE_FOR_ROLE_REQUEST, EDIT_SERVICE_FOR_ROLE_SUCCESS, EDIT_SERVICE_FOR_ROLE_FAILURE],
      config,
    },
  };
}

export function deleteServiceDetailsForRole(roleId, serviceId, salonId) {
  const config = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      service: serviceId,
    }),
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/role/services/${roleId}/`,
      authenticated: true,
      types: [DELETE_SERVICE_FOR_ROLE_REQUEST, DELETE_SERVICE_FOR_ROLE_SUCCESS, DELETE_SERVICE_FOR_ROLE_FAILURE],
      config,
    },
  };
}

function postAllServiceDetailsForRole(allServicesDetails, serviceId, salonId) {
  return (dispatch) => {
    const services = allServicesDetails.filter((svrs) => svrs.role_id !== -1);

    const promises = [];
    services.forEach((srvs) => {
      promises.push(dispatch(postServiceDetailsForRole(srvs, serviceId, salonId)));
    });

    return Promise.all(promises);
  };
}

function deleteRemovedServiceDetailsForRole(responseRoleExecutions, serviceToSend, serviceId, salonId, originalRoleIds) {
  return (dispatch) => {
    if (!originalRoleIds?.length) {
      return Promise.resolve();
    }

    const currentRoleIds = new Set(serviceToSend.role_executions.map(({ role_id: roleId }) => roleId));
    const rolesToDelete = responseRoleExecutions.filter(({ role_id: roleId }) => roleId !== -1 && originalRoleIds.includes(roleId) && !currentRoleIds.has(roleId));

    const promises = rolesToDelete.map(({ role_id: roleId }) => dispatch(deleteServiceDetailsForRole(roleId, serviceId, salonId)));

    return Promise.all(promises);
  };
}

function editAllServiceDetailsForRole(allServicesDetails, serviceId, salonId, updateFlags) {
  return (dispatch) => {
    const services = allServicesDetails.filter((svrs) => svrs.role_id !== -1);

    const promises = [];
    services.forEach((srvs) => {
      promises.push(dispatch(putServiceDetailsForRole(srvs, serviceId, salonId, updateFlags)));
    });

    return Promise.all(promises);
  };
}

export function addService(service, categoryId, salonId) {
  return (dispatch) => {
    dispatch(postService(service, salonId, categoryId)).then(({ response, type }) => {
      if (type === ADD_SERVICE_SUCCESS && response.id) {
        dispatch(postAllServiceDetailsForRole(service.role_executions, response.id, salonId)).then(() => {
          if (response.id) {
            dispatch(
              postServiceTaxesAndFees({
                taxes: service.tax_ids,
                fees: service.fee_ids,
                isTaxExempt: service.is_tax_exempt,
                taxExemptReason: service.tax_exempt_reason,
                serviceId: response.id,
                salonId,
              }),
              // eslint-disable-next-line promise/no-nesting
            ).then(() => {
              if (response.id) {
                // eslint-disable-next-line promise/no-nesting
                dispatch(getService(response.id, salonId))
                  // eslint-disable-next-line promise/no-nesting
                  .then(() => dispatch(getServiceTaxesAndFees({ serviceId: response.id, salonId })).then(() => dispatch(setServiceSaved(true))));
                // eslint-disable-next-line promise/no-nesting
                dispatch(getCategories(salonId));
              }
            });
          }
        });
      }
    });
  };
}

export function editService(
  service,
  salonId,
  updateFlags = {
    update_related_custom_priced_procedures: false,
    update_related_default_priced_procedures: false,
    update_procedures_older_than: moment().startOf('day').toISOString(),
  },
  originalRoleIds,
) {
  const serviceToSend = cloneServiceForEdit(service);

  return async (dispatch) => {
    if (!serviceToSend.id) {
      return;
    }

    const serviceId = serviceToSend.id;

    try {
      const { response, type } = await dispatch(getService(serviceId, salonId));
      if (type !== GET_SERVICE_SUCCESS) return;

      const editedRoleExecutions = asArray(serviceToSend.role_executions);
      const serverRoleExecutions = asArray(response?.role_executions);
      const { editedRoleExecutions: matchedEditedRoleExecutions, serverRoleExecutions: matchedServerRoleExecutions, toPut } = matchRoleExecutionsForUpdate(editedRoleExecutions, serverRoleExecutions);

      serviceToSend.role_executions = matchedEditedRoleExecutions;

      await dispatch(postAllServiceDetailsForRole(serviceToSend.role_executions, serviceId, salonId));
      await dispatch(deleteRemovedServiceDetailsForRole(matchedServerRoleExecutions, serviceToSend, serviceId, salonId, originalRoleIds));
      await dispatch(editAllServiceDetailsForRole(toPut, serviceId, salonId, updateFlags));
      await dispatch(putService(serviceToSend, salonId));

      const { response: taxResponse, type: taxType } = await dispatch(getServiceTaxesAndFees({ serviceId, salonId }));
      if (taxType !== GET_SERVICE_TAXES_AND_FEES_SUCCESS) {
        throw new Error('Failed to load service tax settings');
      }

      const taxSettings = resolveTaxSettingsForSave(serviceToSend, taxResponse?.results);

      await dispatch(
        postServiceTaxesAndFees({
          taxes: taxSettings.taxes,
          fees: taxSettings.fees,
          isTaxExempt: taxSettings.is_tax_exempt,
          taxExemptReason: taxSettings.tax_exempt_reason,
          serviceId,
          salonId,
        }),
      );

      await dispatch(getService(serviceId, salonId));
      await dispatch(getServiceTaxesAndFees({ serviceId, salonId }));
      dispatch(setServiceSaved(true));
    } catch {
      dispatch({ type: EDIT_SERVICE_FAILURE, params: { serviceId } });
    }
  };
}

export function getServiceTemplates() {
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: 'services/v1/templates/',
      authenticated: true,
      types: [GET_SERVICE_TEMPLATES_REQUEST, GET_SERVICE_TEMPLATES_SUCCESS, GET_SERVICE_TEMPLATES_FAILURE],
      config: {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    },
  };
}

export function clearServicesState() {
  return {
    type: CLEAR_SERVICES_STATE,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function removeSavedCategoriesIds(idsToRemove) {
  return {
    type: REMOVE_SAVED_CATEGORIES_IDS,
    idsToRemove,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function removeSavedServicesIds(idsToRemove) {
  return {
    type: REMOVE_SAVED_SERVICES_IDS,
    idsToRemove,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function clearRequestError() {
  return {
    type: CLEAR_REQUEST_ERROR,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function markCategoriesAsFetched() {
  return {
    type: MARK_CATEGORIES_AS_FETCHED,
    meta: {
      analytics: EventTypes.track,
    },
  };
}

export function changeServicePosition(serviceToInsert, serviceAt) {
  return {
    type: CHANGE_SERVICE_POSITION,
    serviceToInsert,
    serviceAt,
  };
}

export function saveServicesPositions(salonId, categoryId, ids) {
  const config = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(ids),
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/service/${categoryId}/sort/`,
      authenticated: true,
      types: [SAVE_SERVICE_POSITIONS_REQUEST, SAVE_SERVICE_POSITIONS_SUCCESS, SAVE_SERVICE_POSITIONS_FAILURE],
      config,
    },
  };
}

export function changeCategoryPosition(categoryToInsert, categoryAt) {
  return (dispatch, getState) => {
    dispatch({
      type: CHANGE_CATEGORY_POSITION,
      categoryToInsert,
      categoryAt,
    }).then(() => {
      const config = {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(getState().onboarding.services.categories.map((cat) => cat.id || 0)),
      };
      dispatch({
        [AUTH_API]: {
          api_root: CONF.apiRoot,
          endpoint: `services/v1/salon/${getState().currentSalon.id}/category/sort/`,
          authenticated: true,
          types: [SAVE_CATEGORY_POSITIONS_REQUEST, SAVE_CATEGORY_POSITIONS_SUCCESS, SAVE_CATEGORY_POSITIONS_FAILURE],
          config,
        },
      });
    });
  };
}

export function saveCategoryPositions(salonId, categoryIds) {
  const config = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(categoryIds),
  };
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint: `services/v1/salon/${salonId}/category/sort/`,
      authenticated: true,
      types: [SAVE_CATEGORY_POSITIONS_REQUEST, SAVE_CATEGORY_POSITIONS_SUCCESS, SAVE_CATEGORY_POSITIONS_FAILURE],
      config,
    },
  };
}

export function getFutureAppointmentsWithService(salonId, serviceId, differentPricesRolesIds, checkFromDate) {
  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      // eslint-disable-next-line max-len
      endpoint: `services/v1/salon/${salonId}/role/services/procedures/?start_time=${checkFromDate}&execution_ids=${differentPricesRolesIds.join(',')}`,
      authenticated: true,
      types: [GET_FUTURE_APPOINTMENTS_WITH_SERVICE_REQUEST, GET_FUTURE_APPOINTMENTS_WITH_SERVICE_SUCCESS, GET_FUTURE_APPOINTMENTS_WITH_SERVICE_FAILURE],
    },
  };
}

export function clearFutureAppointmentsData() {
  return {
    type: CLEAR_FUTURE_APPOINTMENTS_DATA,
  };
}
